import React from 'react';
import { Input, Textarea } from '@roger/ui-components';
import { Question } from '../types';

interface TextQuestionProps {
  question: Question;
  value: string;
  onChange: (value: string) => void;
}

export const TextQuestion: React.FC<TextQuestionProps> = ({
  question,
  value,
  onChange,
}) => {
  // Determine if this should be a textarea based on question content
  const shouldUseTextarea =
    question.question.toLowerCase().includes('describe') ||
    question.question.toLowerCase().includes('explain') ||
    question.question.toLowerCase().includes('details') ||
    question.question.toLowerCase().includes('comments');

  return (
    <div className='space-y-3'>
      <label className='text-sm font-medium text-gray-900 block'>
        {question.description}
        {question.qid && (
          <span className='ml-2 text-xs text-gray-500'>({question.qid})</span>
        )}
      </label>

      {shouldUseTextarea ? (
        <Textarea
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          className='min-h-[100px]'
          placeholder='Enter your response...'
        />
      ) : (
        <Input
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          placeholder='Enter your response...'
          className='max-w-md'
        />
      )}
    </div>
  );
};
